import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";
import { useFinanceSettingsStore } from "../store";

export const createDefaultChartOfAccounts = ({ churchId, accountData }) => {
  return axios.post(
    `/churches/${churchId}/create-default-accounts`,
    accountData
  );
};

export const useCreateDefaultChartOfAccounts = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const closeDefaultChartOfAccountsModal =
    useFinanceSettingsStore.getState().closeDefaultChartOfAccountsModal;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("chart-accounts");

      setNotification({
        type: "success",
        message: "Default chart of accounts created successfully!"
      });

      closeDefaultChartOfAccountsModal();
    },
    ...config,
    mutationFn: createDefaultChartOfAccounts
  });
};
